import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IUser } from '../models/user.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UsersService {
  private readonly baseUrl = environment.api_url;

  constructor(private readonly http: HttpClient) {}

  getAllUsers(
    userType: string, 
    search: string = '', 
    page: number = 1, 
    pageSize: number = 20,
    sort?: string, 
    order?: 'asc' | 'desc'
  ) {
    const params: string[] = [
      `type=${userType}`,
      `page=${page}`,
      `page_size=${pageSize}`
    ];

    if (sort) {
      params.push(`sort=${sort}`);
    }

    if (order) {
      params.push(`order=${order}`);
    }

    if (search) {
      params.push(`search=${search}`);
    }
        
    const queryString = params.join('&');
    const url = `${this.baseUrl}/api/users/get-my-users?${queryString}`;
    return this.http.get(url);    
  }

  getUserById(id: number) {
    return this.http.get(`${this.baseUrl}/api/users/get-user-by-id?user_id=${id}`);
  }
  
  createUser(userData: IUser) {
    return this.http.post(`${this.baseUrl}/api/users/add-user`, userData);
  }

  updateUser(user_id: number, userData: Partial<IUser>) {
    return this.http.put(`${this.baseUrl}/api/users/${user_id}`, userData);
  }

  updateProfile(userData: Partial<IUser>){
    return this.http.put(`${this.baseUrl}/api/users/update-profile`, userData);
  }
  
  deleteUser(id: number) {
    return this.http.delete(`${this.baseUrl}/api/users/delete-user?user_id=${id}`);
  }

  resetPassword(user_id: number, new_password: string) {
    const body = { user_id, new_password };
    return this.http.post(`${this.baseUrl}/api/users/reset-password`, body);
  }

  resetMyPassword(username: string, old_password: string, new_password: string) {
    const body = { username, old_password, new_password };
    return this.http.post(`${this.baseUrl}/api/users/reset-password-by-old-password`, body);
  }

  checkUsernameExists(username: string): Observable<{ exists: boolean }> {
    return this.http.post<{ exists: boolean }>(`${this.baseUrl}/api/users/check-username-exists`, { username });
  }

  checkPhoneExists(phone: string): Observable<{ exists: boolean }> {
    return this.http.post<{ exists: boolean }>(`${this.baseUrl}/api/users/check-phone-exists`, { phone });
  }

  getResellers(search: string = '', page_size: number = 20): Observable<any> {
    let params = new HttpParams().set('search', search);
    if (page_size) {
      params = params.set('page_size', page_size.toString());
    }
    return this.http.get(`${environment.api_url}/api/users/get-resellers`, { params });
  }

}
